module.exports = __webpack_public_path__ + "c3f3f7dc4cd7e5b18340338587a86b07.svg";